export enum DoctorUserDTOStatus {
  Active = 'ACTIVE',
  WaitingForActivation = 'WAITING_FOR_ACTIVATION',
  NeedPasswordChange = 'NEED_PASSWORD_CHANGE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
}
